/* global globalThis */
import React from 'react';
import PropTypes from 'prop-types';
import { CNavLink } from "./c/CHeader";
import { Tooltip, ListItem, ListItemText, Box } from "@material-ui/core";
import { setSubdomain } from 'sdk/actions/getSettingsAction';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { logoutUser } from 'sdk/services/userService';
import { useUrlInfo } from 'sdk/custom-hooks';

/**
 * MobileMenuList
 * @param props
 * @returns {*}
 * @constructor
 */
function MobileMenuList(props) {
    const { t, openDrawerStatus, screenWidth, handleDrawerClose, openFeedbackModel } = props;
    const dispatch = useDispatch();
    const { currentHost } = useUrlInfo();
    const shouldCloseDrawerOnMobile = Boolean(screenWidth && screenWidth <= 800);

    const closeDrawerOnMobile = () => {
      if (shouldCloseDrawerOnMobile) {
        handleDrawerClose();
      }
    };

    const handleFeedbackClick = () => {
      closeDrawerOnMobile();
      openFeedbackModel();
    };

    const logout = async () => {
      logoutUser()
        .then((response) => {
          if (response?.status === 200) {
            localStorage.clear();
            Object.keys(Cookies.get()).forEach((cookieName) => {
              Cookies.remove(cookieName, {
                path: "/",
                domain: currentHost,
                secure: true,
              });
            });

            dispatch(setSubdomain(null));
            globalThis.ReactNativeWebView?.postMessage(
              JSON.stringify({
                type: "LOGOUT",
              })
            );

            const returnToUrl = response?.data?.returnToUrl;

            if (
              process.env.NODE_ENV === "production" ||
              process.env.NODE_ENV === "staging"
            ) {
              globalThis.location.href = returnToUrl;
            } else {
              globalThis.location.href = "/login";
            }
          } else {
            console.log("Something went wrong during logout.");
          }
        })
        .catch((error) => {
            console.log(error.message);
        });
    };

    return (
        <React.Fragment>
            <CNavLink to="/my-profile">
                <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Settings'} aria-label="Settings">
                <ListItem button onClick={closeDrawerOnMobile}>
                        <i className="fa fa-cog m-r-18"/>
                        <ListItemText primary={t('settings')}/>
                    </ListItem>
                </Tooltip>
            </CNavLink>

            <Box>
                <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Feedback'} aria-label="Feedback"
                         className="bottom-link">
                <ListItem button onClick={handleFeedbackClick}>
                        <i className="fa fa-comments-o m-r-16"/>
                        <ListItemText primary={t('feedback')}/>
                    </ListItem>
                </Tooltip>
            </Box>
            <Box onClick={logout}>
                <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Logout'} aria-label="Logout"
                         className="bottom-link">
                <ListItem button onClick={closeDrawerOnMobile}>
                        <i className="fa fa-sign-out m-r-18"/>
                        <ListItemText primary={t('logout')}/>
                    </ListItem>
                </Tooltip>
            </Box>
        </React.Fragment>
    );
}

      MobileMenuList.propTypes = {
        t: PropTypes.func.isRequired,
        openDrawerStatus: PropTypes.bool,
        screenWidth: PropTypes.number,
        handleDrawerClose: PropTypes.func,
        openFeedbackModel: PropTypes.func
      };

export default MobileMenuList;
